import axios from 'axios';

const state = {
  data: [],
};

const mutations = {
  data(state, value) {
    state.data = value;
  },
};

const actions = {
  call({ commit }, body) {
    return new Promise((resolve, reject) => {
      axios.post('metrics/calls/averages', body)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  queue({ commit }, body) {
    return new Promise((resolve, reject) => {
      axios.post('metrics/queues/averages', body)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
};

const getters = {
  data: state => state.data,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
